import React from 'react';
import { formatCurrencyAmount } from '../../utils/library';
import { CLOSE_NEW_ICON } from '@Images';
import {
  IpsBreakdownContainer as ModalContainer,
  CloseWrapper,
  ModalTitle,
  BreakdownRow,
  RowLabel,
  RowValue,
  RowSubLabel,
  RowWrapper,
  ButtonWrapper,
  Border
} from './styles';
import { CommonButton } from '@Components';
import { IpsBreakdownModalProps } from './types';

const IpsBreakdownModal = ({
  onClose,
  ip_balance,
  ip_balance_transactions,
  ip_balance_referral
}: IpsBreakdownModalProps) => {
  return (
    <ModalContainer>
      <CloseWrapper>
        <img src={CLOSE_NEW_ICON} height={24} width={24} alt="close" onClick={() => onClose()} />
      </CloseWrapper>
      <ModalTitle>InstaPoints breakdown</ModalTitle>
      <BreakdownRow>
        <RowWrapper>
          <RowLabel>Transactions</RowLabel>
          <RowSubLabel>(Remittance + amaze)</RowSubLabel>
        </RowWrapper>
        <RowValue>{formatCurrencyAmount(ip_balance_transactions)} IPs</RowValue>
      </BreakdownRow>
      <BreakdownRow>
        <RowLabel>Referrals</RowLabel>
        <RowValue>{formatCurrencyAmount(ip_balance_referral)} IPs</RowValue>
      </BreakdownRow>
      <Border />
      <BreakdownRow>
        <RowLabel>Total balance</RowLabel>
        <RowValue $isNegative={ip_balance < 0}>{formatCurrencyAmount(ip_balance)} IPs</RowValue>
      </BreakdownRow>
      <ButtonWrapper>
        <CommonButton
          text="Got it"
          fontWeight={700}
          type="primary"
          id="got-it"
          onClick={() => onClose()}
        />
      </ButtonWrapper>
    </ModalContainer>
  );
};

export default IpsBreakdownModal;
